import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ManagingCompanies} from "@/models/ManagingCompanies";
import {AbstractAuthentication, AuthenticationRequest, CompanyDetailsResponse} from '@payroll/optimus-common'
import $ from 'jquery'
import Component from 'vue-class-component'
import {Inject, Prop, Watch} from 'vue-property-decorator'
import {Action, Getter, Mutation} from 'vuex-class'

const variables = require('@/assets/styles/_variables.scss')

@Component({})
export default class LoginContainerComponent extends AfterFetchComponent {

    @Inject() $validator: any

    @Prop() auth!: AbstractAuthentication
    @Prop() fillUserAgent!: boolean
    @Prop() buttonText!: string
    @Prop() passwordLabelProp!: string
    @Prop() serverErrors!: string[]
    @Prop() loginHeaderTitle!: string
    @Prop() showForgot!: boolean
    @Prop() showApplication!: boolean
    @Prop() hideIdNumberFieldProp!: boolean
    @Prop() hidePasswordFieldProp!: boolean
    @Prop() checkMangingCompanyProp!: boolean
    @Prop() tooltipMessage!: string
    @Prop() managingCompany!: string
    @Prop() loginLoading!: boolean

    private passwordLabel = 'password'
    private hideIdNumberField = false
    private hidePasswordField = false
    private checkMangingCompany = false
    private showReCaptcha = false

    @Action('getManagingCompanyConfig', StoreNamespace.AUTHENTICATION) getManagingCompanyConfig: any
    @Action('resetStore') resetStore: any
    @Mutation('setMngCompanyName', StoreNamespace.AUTHENTICATION) setMngCompanyName: any
  @Mutation('setOprEntityKey', StoreNamespace.AUTHENTICATION) setOprEntityKey: any
    @Mutation('setCustomerDetails', StoreNamespace.AUTHENTICATION) setCustomerDetails: any
    @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string
    @Getter('customerDetails', StoreNamespace.AUTHENTICATION) customerDetails!: CompanyDetailsResponse

    beforeMount() {
        this.initManagingCompany()
    }

    @Watch('$route')
    onRouteChanged(newVal: any, oldVal: any) {
        $('body').removeClass(oldVal.params.managingCompany)
        this.initManagingCompany()
    }

    initManagingCompany(): void {
        let managingCompany: string = this.$route.params.managingCompany || this.managingCompany

        this.checkMangingCompany = this.checkMangingCompanyProp
        if (this.checkMangingCompany) {
            this.resetStore()
            this.getManagingCompanyConfig({
                pathVariable: managingCompany,
                requestorCallback: this
            })
        } else {
            this.loading = false
        }
        $('body').addClass(managingCompany)
        this.$Progress.setColor(variables[managingCompany + '-secondary'])
    }

    mounted() {
        if (this.passwordLabelProp) {
            this.passwordLabel = this.passwordLabelProp
        }
        this.hideIdNumberField = this.hideIdNumberFieldProp ? this.hideIdNumberFieldProp : false
        this.hidePasswordField = this.hidePasswordFieldProp ? this.hidePasswordFieldProp : false
        $(document).ready(function () {
            $('form:first *:input[type!=hidden]:first').focus();
        })

        this.showReCaptcha = this.customerDetails.mode !== 'dev'
    }

    onSubmit() {
        if (this.$route.params.managingCompany &&
            (this.auth.managingCompany !== this.$route.params.managingCompany || this.mngCompanyName !== this.$route.params.managingCompany)) {
            this.auth.managingCompany = this.$route.params.managingCompany
            this.setMngCompanyName(this.$route.params.managingCompany);
        }

        if (this.fillUserAgent) {
            this.setUserAgent()
        }

        if (this.showReCaptcha) {
            this.$recaptchaLoaded().then(() =>
                this.$recaptcha('login')
                    .then(response => {
                        this.auth.recaptchaResponse = response
                        this.$emit('submitLogin')
                    })
                    .catch(() => this.onError([this.$t('recaptcha_error').toString()], 400))
            )
        } else {
            this.$emit('submitLogin')
        }
    }

    setUserAgent() {
        var loginAuth = this.auth as AuthenticationRequest
        loginAuth.siteUrl = document.URL
        loginAuth.browserInfo = navigator.userAgent
        loginAuth.isMobile = this.isItMobile()
    }

    get joinServiceRequest(): any {
        return this.$route.params.managingCompany
    }

    isItMobile() {
        var check = false;
        (function (a: string) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor);
        return check;
    }

    onForgetPasswordClick(): void {
        this.$router.push({name: 'forgot'})
    }

    onJoinServiceClick(): void {
        this.$router.push({name: 'employer-registration'})
    }

    onSuccess(data?: any, requestName?: string, message?: string): void {
        let managingCompany: string = this.$route.params.managingCompany || this.managingCompany
        this.setMngCompanyName(managingCompany)
        this.setCustomerDetails(data)
        $('body').addClass(managingCompany)

      if (requestName === "getManagingCompanyConfig") {
        this.setOprEntityKey(data.oprEntityKey)
      }
    }

    onError(messages: string[], code: number, requestName?: string): void {
        if (this.$validator) {
            this.$validator.reset()
        }

        const managingCompany: string = this.$route.params.managingCompany || this.managingCompany
        $('body').removeClass(managingCompany)

        let errorPage: string = 'error'
        switch (code) {
            case 401:
            case 403:
                errorPage = 'session-timeout'
                break
            case 404:
                errorPage = 'not-found'
                break
            case 503:
                errorPage = 'maintenance'
                break
            default:
                errorPage = 'error'
        }
        this.$router.push({name: errorPage})
    }

  get mngCompanyNameToDisplay() {

    switch (this.mngCompanyName.toUpperCase()) {
      case ManagingCompanies.HISHTALMUT_OTZEM:
        return this.$t('otzem_hishtalmut')
      case ManagingCompanies.GEMEL_OTZEM:
        return this.$t('otzem_gemel')
      default:
        return ''
    }
  }


}